// extracted by mini-css-extract-plugin
export default {"Tooltip":"TooltipBody_Tooltip__VAmoF","Container":"TooltipBody_Container__tSlT6","Content":"TooltipBody_Content__j9TDw"};